import utility from './lib/utility'
import toolbar from './lib/toolbar'
import jarvisUrlParams from './lib/jarvisUrlParams'
import tenantService from './lib/tenantService'
import multiViewControls from './lib/multiViewControls'
import viewersManipulation from './lib/viewers/viewersManipulation'
import metadata from './lib/metadata'
import initialPosition from './lib/initialPosition'
import OpenSeadragon from 'openseadragon'
import navigator from './lib/navigator'

const pasiJsonData = require('./lib/kiosk/pasiData.json')

let currentViewersList = []

utility.blockRightClick()

const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)

const culturalItemUuid = urlParams.get('culturalItemUuid')
let multi = urlParams.get('multi')
let language = urlParams.get('lang')

const uuids = jarvisUrlParams.extractUuids(urlParams)

const imageUuid = urlParams.get('uuid')

const pasiData = urlParams.get('pasiData')
if (pasiData) {
  multi = pasiJsonData[pasiData].imagesUuids.join('_')
}

const largeIcons = urlParams.get('onPremises')

let uuidList = []

uuidList = (() => {
  if (imageUuid) {
    return [imageUuid]
  }
  if (multi) {
    return multi.split('_')
  }
  if (uuids) {
    return uuids
  }
  return []
})()

function getViewers() {
  return currentViewersList
}

window.getViewers = getViewers
global.getViewers = getViewers

window.addEventListener(
  'message',
  event => {
    window.frameTargetOrigin = event.origin
    let payload = event.data
    if (payload !== undefined) {
      //console.log(payload)
      let target = payload.target
      if (target && target.startsWith('viewport')) {
        let viewportOption = undefined
        if (target.includes('.')) {
          viewportOption = target.split('.')[1]

          for (const viewer of getViewers()) {
            if (!viewer.viewport[`${viewportOption}_default`]) {
              viewer.viewport[`${viewportOption}_default`] = {}
              for (const param in viewer.viewport[viewportOption]) {
                viewer.viewport[`${viewportOption}_default`][param] = viewer.viewport[viewportOption][param]
              }
            }

            if (payload.method === 'reset') {
              for (const param in viewer.viewport[`${viewportOption}_default`]) {
                viewer.viewport[viewportOption][param] = viewer.viewport[`${viewportOption}_default`][param]
              }
            } else {
              for (const param in payload.parameters) {
                viewer.viewport[viewportOption][param] = payload.parameters[param]
              }
            }
          }
        } else {
          payload.parameters = payload.parameters.map(param => {
            return param._type !== undefined ? new OpenSeadragon[param._type](...param.parameters) : param
          })
          getViewers()[0].viewport[payload.method](...payload.parameters)
        }
      } else if (target === 'button') {
        let element = document.getElementById(payload.buttonId)
        buttonEventFromParent(element, payload.event)

        switch (payload.buttonId) {
          case 'home':
            if (payload.event === 'click') {
              for (let viewer of getViewers()) {
                viewer.viewport.goHome()
              }
            }
            break
          case 'rotate':
            if (payload.event === 'click') {
              for (let viewer of getViewers()) {
                viewer.viewport.setRotation(viewer.viewport.getRotation() + viewer.rotationIncrement)
              }
            }
            break
          case 'navigatorWithButtons':
            if (payload.event === 'hide') {
              navigator.hide()
            } else if (payload.event === 'show') {
              navigator.show()
            }
            break
        }
      }
    }
  },
  false
)

function buttonEventFromParent(element, event) {
  if (event === 'click') {
    element.click()
  } else if (event === 'hide') {
    element.classList.add('hidden')
  } else if (event === 'show') {
    element.classList.remove('hidden')
  }
}

let globalImagesData = []

let customUIName = urlParams.get('customUIName')
if (!customUIName) {
  tenantService.getTenantName().then(tenantName => (customUIName = tenantName))
}

document.addEventListener('change-to-mode-split', () => {
  const currentRotation = currentViewersList[0].viewport.getRotation()
  const currentPosition = currentViewersList[0].viewport.getBounds(true)
  multiViewControls.saveState()
  viewersManipulation.cleanViewers(currentViewersList, globalImagesData)

  currentViewersList = viewersManipulation.createViewerSplit(globalImagesData, customUIName)
  multiViewControls.restoreState(currentPosition, currentRotation)
})

document.addEventListener('change-to-mode-container', () => {
  const currentRotation = currentViewersList[0].viewport.getRotation()
  viewersManipulation.resetViewerRotation(currentViewersList[0])
  const currentPosition = currentViewersList[0].viewport.getBounds(true)
  const numberOfViewers = multiViewControls.saveState()
  viewersManipulation.cleanViewers(currentViewersList, globalImagesData)

  currentViewersList = viewersManipulation.createViewerDefault(
    globalImagesData,
    customUIName,
    numberOfViewers,
    largeIcons
  )
  multiViewControls.restoreState(currentPosition, currentRotation)
})

document.addEventListener('change-to-mode-layers', () => {
  const currentRotation = currentViewersList[0].viewport.getRotation()
  const currentPosition = currentViewersList[0].viewport.getBounds(true)
  multiViewControls.saveState()
  viewersManipulation.cleanViewers(currentViewersList, globalImagesData)

  currentViewersList = viewersManipulation.createViewerLayers(globalImagesData, customUIName)
  multiViewControls.restoreState(currentPosition, currentRotation)
})

let retrieveMetadata = () => metadata.getImagesData(uuidList)

if (culturalItemUuid) {
  retrieveMetadata = () => metadata.getCulturalItemData(culturalItemUuid)
}

window.addEventListener('selectImageFromCatalog', e => {
  currentViewersList.forEach(viewer => viewer.goToPage(e.detail.imageIndex))
})

retrieveMetadata().then(imagesData => {
  const percentage = 100 / imagesData.length
  imagesData.forEach((data, index) => {
    data.id = index
    data.isMainViewer = index === 0
    data.viewerId = `viewer${index}`
    data.percentage = percentage
    data.left = percentage * index
    data.multi = multi
  })

  globalImagesData = imagesData

  if (pasiData) {
    toolbar.createPasiToolbarDom()
    viewersManipulation.createViewerOnPremises(imagesData, pasiJsonData[pasiData][language])
  } else {
    let thumbLinks = imagesData[0].thumbLinks || []
    console.log(imagesData[0])

    toolbar.createToolbarDom(
      imagesData[0].ppi,
      multi,
      imagesData[0].canRotate,
      largeIcons,
      imagesData[0].tileSources.length,
      imagesData[0].title,
      thumbLinks.map(thumb => thumb.href)
    )
    currentViewersList = viewersManipulation.createViewerDefault(
      imagesData,
      customUIName,
      false,
      largeIcons,
      initialPosition.createFrom(urlParams)
    )
  }

  enableImagesLazyLoad()
})

function enableImagesLazyLoad() {
  const imagesToLazyLoad = document.querySelectorAll('.lazy')

  const imageObserver = new IntersectionObserver(function (intersections) {
    intersections.forEach(function (intersection) {
      if (intersection.isIntersecting) {
        intersection.target.classList.remove('lazy')
      }
    })
  })

  imagesToLazyLoad.forEach(function (image) {
    imageObserver.observe(image)
  })
}
